// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"d312ac79","239":"649b4af5","455":"4be229c9","488":"f18afcd0","977":"0cd5cd79"}[chunkId] + ".chunk.js";
};